import { useCallback, useMemo } from "react";
import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getFeature } from "@Libs/FeatureFlags/services/features";
import { IServiceFeesFeature } from "../services/serviceFeesFeature";

export const useServiceFeesFeature = () => {
  const {
    data: serviceFeesFeature,
    isLoading,
    isError,
    isSuccess,
    status,
  } = useDataQuery<IServiceFeesFeature>("serviceFeesFeature", () =>
    getFeature<IServiceFeesFeature>("service_fees").then(({ data }) => data)
  );

  const getClientServiceFee = useCallback(
    (amount: number) => {
      if (serviceFeesFeature && amount) {
        const { percentage } =
          serviceFeesFeature.details.chargedToClient.clientServiceFee;

        return percentage ? (amount * percentage) / 100 : 0;
      }

      return 0;
    },
    [serviceFeesFeature]
  );

  const isEnabled = useMemo(() => {
    if (isLoading) return false;

    if (isError) return false;

    if (isSuccess) {
      return serviceFeesFeature.enabled;
    }
  }, [isLoading, isError, isSuccess, serviceFeesFeature]);

  return {
    serviceFeesFeature,
    getClientServiceFee,
    isLoading,
    isError,
    isSuccess,
    status,
    isEnabled,
  };
};
